import {
  truckImg1,
  truckImg10,
  truckImg2,
  truckImg3,
  truckImg4,
  truckImg5,
  truckImg6,
  truckImg7,
  truckImg8,
  truckImg9,
} from 'images/services';

type TEquipmentList = {
  title: string;
  text: string;
  image: string;
};

export const equipmentList: TEquipmentList[] = [
  {
    title: 'Straight Truck',
    text: 'Used to haul less cargo than a semi but a lot more maneuverable in tight streets.',
    image: truckImg1,
  },
  {
    title: 'Dry Van Trailer',
    text: 'Fully enclosed and protects freight from outside elements. ',
    image: truckImg2,
  },
  {
    title: 'Step Deck Trailers',
    text: 'For tall cargo and to avoid height restrictions.',
    image: truckImg3,
  },
  {
    title: 'Conestoga Trailers',
    text: 'Unfolding trap trailer that covers your freight without damaging the finish',
    image: truckImg4,
  },
  {
    title: 'Flatbed Trailers',
    text: 'Used to haul large equipment that would not normally fit into a standard covered trailer.',
    image: truckImg5,
  },
  {
    title: 'Lowboy Trailer',
    text: 'Designed to haul heavy construction equipment and machinery.',
    image: truckImg6,
  },
  {
    title: 'Stretch RGN Trailers',
    text: 'Carries freight that is too long for a standard RGN.',
    image: truckImg7,
  },
  {
    title: 'RGN Trailer',
    text: 'Designed to haul heavy equipment. Low height allows for easy loading and provides extra stability.',
    image: truckImg8,
  },
  {
    title: 'Refrigerated  Trailer',
    text: 'Or a “reefer” has a refrigeration unit to cool or heat temperature-sensitive freight.\n',
    image: truckImg9,
  },
  {
    title: 'Car Hauler',
    text: 'A car-carrying trailer designed to efficiently move passenger vehicles. ',
    image: truckImg10,
  },
];
